import { createStyles, makeStyles, Theme } from "@material-ui/core"
import * as React from "react"
import { formatAmount } from "../../../utils/format"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    summary: {
      display: "grid",
      gap: theme.spacing(1),
    },
    summaryRow: {
      color: "#A5C2D6",
    },
    summaryValue: {
      color: "#ffffff",
    },
  }),
)

interface ISideBarTableProps {
  quoteData: { quote: any; quoteLoading: boolean; quoteMessage: string }
}

const SideBarTable: React.FunctionComponent<ISideBarTableProps> = ({
  quoteData,
}) => {
  const classes = useStyles()
  const fees = quoteData.quote.transactionFee + quoteData.quote.bankTransfer
  const totalAmount = quoteData.quote.advanceAmount + fees

  return (
    <div className={classes.summary}>
      <div className={classes.summaryRow}>
        Your fees come to{" "}
        <span className={classes.summaryValue}>R{formatAmount(fees)}</span>
        .
      </div>
      <div className={classes.summaryRow}>
        The deduction date is{" "}
        <span className={classes.summaryValue}>
          {quoteData.quote.salaryDeductionDate}
        </span>
        .
      </div>
      <div className={classes.summaryRow}>
        The total amount is{" "}
        <span className={classes.summaryValue}>
          R{formatAmount(totalAmount)}
        </span>
        .
      </div>
    </div>
  )
}

export default SideBarTable
